import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {HttpService} from '../../../../../core';
import {ToastrService} from 'ngx-toastr';


@Component({
    selector: 'app-status-dialog',
    templateUrl: './status-dialog.component.html',
    styleUrls: ['./status-dialog.component.scss']
})

export class StatusDialogComponent implements OnInit {
    constructor(
        private dialogRef: MatDialogRef<any>,
        private httpService: HttpService,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private toastrService: ToastrService
    ) {
    }

    ngOnInit(): void {
        console.log(this.data);
    }

    changeStatus() {
        const fd = new FormData();
        fd.append('status', this.data.targetStatus);
        this.httpService.updateProject(fd, this.data.project.id).subscribe((res: any) => {
            console.log(res);
            if (res.code === 1) {
                this.toastrService.success('Status has been updated');
                this.dialogRef.close({result: res});
            } else {
                this.toastrService.warning('Cannot modify status');
                this.dialogRef.close({result: res});
            }
        });
    }
}
